import React, { useEffect, useState } from "react";
import Popover from "@mui/material/Popover";
import Grow from "@mui/material/Grow";

const checkboxLabelStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  margin: 0,
  cursor: "pointer",
  fontFamily: "CircularSTDBook, sans-serif",
  fontSize: "14px",
  color: "var(--qv-tx-000000, #000000)",
  lineHeight: "20px",
  fontWeight: 400,
};

const checkboxStyle = {
  width: "16px",
  height: "16px",
  margin: 0,
  flexShrink: 0,
  cursor: "pointer",
  accentColor: "#0a64f9",
};

const ItemSalesColumnPicker = ({
  columnsOptions,
  selectedColumns,
  setSelectedColumns,
  applyColumns,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectAllColumns, setSelectAllColumns] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "item-sales-column-picker" : undefined;

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setSelectedColumns((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSelectAllChange = (event) => {
    const { checked } = event.target;
    setSelectAllColumns(checked);
    const updatedColumns = columnsOptions.reduce((acc, col) => {
      acc[col.id] = checked;
      return acc;
    }, {});
    setSelectedColumns((prev) => ({
      ...prev,
      ...updatedColumns,
    }));
  };

  useEffect(() => {
    const allSelected =
      columnsOptions.length > 0 &&
      columnsOptions.every((col) => selectedColumns[col.id]);
    setSelectAllColumns(allSelected);
  }, [selectedColumns, columnsOptions]);

  return (
    <>
      <div
        aria-describedby={id}
        onClick={handleClick}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          padding: "0 4px",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          aria-label="Add columns"
        >
          <path
            d="M8 2v6H2v2h6v6h2V10h6V8h-6V2H8z"
            fill="#FFFFFF"
          />
        </svg>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableRestoreFocus
        disableEnforceFocus
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        TransitionComponent={Grow}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
            width: "320px",
            overflow: "hidden",
          },
        }}
      >
        <div
          style={{
            padding: "8px",
            fontFamily: "CircularSTDBook, sans-serif",
            fontSize: "14px",
            color: "var(--qv-tx-000000, #000000)",
          }}
        >
          <label
            style={{
              ...checkboxLabelStyle,
              backgroundColor: "var(--qv-bg-f8f8f8, #F8F8F8)",
              padding: "10px 12px",
              marginBottom: "14px",
              borderRadius: "4px",
              gap: "12px",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <input
              type="checkbox"
              checked={selectAllColumns}
              onChange={handleSelectAllChange}
              style={checkboxStyle}
            />
            Select All
          </label>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              columnGap: "16px",
              rowGap: "14px",
              padding: "0 8px 4px",
            }}
          >
            {columnsOptions.map((col) => (
              <label key={col.id} style={checkboxLabelStyle}>
                <input
                  type="checkbox"
                  name={col.id}
                  checked={!!selectedColumns[col.id]}
                  onChange={handleCheckboxChange}
                  style={checkboxStyle}
                />
                {col.name}
              </label>
            ))}
          </div>

          <div style={{ marginTop: "16px", padding: "0 4px 4px" }}>
            <button
              type="button"
              onClick={() => {
                applyColumns();
                handleClose();
              }}
              style={{
                background: "#0a64f9",
                fontFamily: "CircularSTDBook, sans-serif",
                fontSize: "14px",
                fontWeight: 400,
                color: "#ffffff",
                padding: "8px 30px",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                lineHeight: "20px",
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </Popover>
    </>
  );
};

export default ItemSalesColumnPicker;
